module.exports = __webpack_public_path__ + "static/media/pickup.0d1477b8.svg";